import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { c as S } from "./index.CWkFp9WS.js";
import { memo as u } from "react";
import { O as l } from "./ODSIcon.DjL6Q3o4.js";
import { O } from "./ODSRow.Du_e7gfN.js";
import { O as f } from "./ODSText.D6mgyggF.js";
import '../assets/ODSSupportMessage.css';function d(e) {
  return e === "error" ? "error-type-bold" : e === "success" ? "success-type-bold" : "information-type-bold";
}
const g = ({
  className: e,
  type: t = "informative",
  mode: a = "informative",
  disabled: p = !1,
  message: m,
  helperText: n,
  ...i
}) => {
  const s = a ?? t, r = n ?? m;
  return /* @__PURE__ */ c(
    O,
    {
      className: S(
        "ODSSupportMessage",
        `ODSSupportMessage--mode-${s}`,
        p && "ODSSupportMessage--disabled",
        e
      ),
      ...i,
      children: [
        /* @__PURE__ */ o(
          l,
          {
            name: d(s),
            className: "ODSSupportMessage-Icon",
            "aria-hidden": !0
          }
        ),
        r && /* @__PURE__ */ o(f, { as: "span", className: "ODSSupportMessage-Label", children: r })
      ]
    }
  );
}, y = u(g);
export {
  y as O
};
//# sourceMappingURL=ODSSupportMessage.DxN3bpZC.js.map
